<template>
    <el-dialog :visible.sync="show"
        :title="$t('privateNetInstance.unBindTitle')"
        :close-on-click-modal="false"
        :before-close="handleClose"
        @closed="onClosed"
        size="tiny"
        class="del-root">
        <p>{{$t('privateNetInstance.sureUnBindTip', [rowInfo.elasticIp])}}</p>
        <div v-if="show" slot="footer" class="dialog-footer">
            <el-button @click="cancelUnbind" :disabled="loading">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="sureUnbind" type="primary" :disabled="loading" :loading="loading">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'UnBindEip',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        rowInfo: {
            type: Object,
            default: {}
        },
        region: {
            type: String,
            default: ''
        },
        natId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false,
            loading: false, // 添加loading状态
        };
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    },
    methods: {
        onClosed() {
          this.loading = false;
        },
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        cancelUnbind() {
            this.handleClose();
        },
        sureUnbind() {
            // 防止重复点击
            if (this.loading) return;
            
            this.loading = true;
            
            const params = {
                region: this.rowInfo.region,
                eipIds: [this.rowInfo.elasticIpId],
                natGatewayId: this.natId,
                clientToken: this.clientToken,
                type: 'disassociate',
            };
            Ajax.put('/api/cps/nat/operateBind', params, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((res) => {
                this.$message.success(this.$t('privateNetInstance.operateSuccess'));
                handleClose()
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                // 立即关闭弹窗，但保持loading状态更长时间
                this.handleClose();
                this.$emit('refresh');
                // 延迟重置loading状态，确保弹窗完全消失后才移除遮罩
                // 设置1200ms确保用户有足够时间看到处理结果，且无法点击
                // setTimeout(() => {
                //     this.loading = false;
                // }, 1200);
            });
           
        }
    },
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/nat/UnBindEip.vue